import { HttpHeaders } from "@angular/common/http";
import { environment } from '../../environments/environment';

export class General {
}

// let credential = false

export let baseUrl = environment.apiURL;
export let baseUrl2 = environment.apiURL2;
export let loginUrl = environment.apiLoginURL;
export let imageURL = environment.imageURL;
export const httpOptions = {
    headers: new HttpHeaders({
      'APPSecret': 'fLP3Dgvf7habt1qQMXHfFOWaHVXyNw7zEmbv0QMpURu',
      // Accept: "application/json",
      // "Content-Type": "application/json",
      'APPKey': 'a96834df-0821-4956-a0f2-2df3c23bde25',
    }),
  };

  export const httpAuthOptions = {
    headers: new HttpHeaders({
      'channel': '1',
    }),
  };

  export interface FormatDateTimeOptions {
    timeZone?: string;         // IANA timezone, e.g. 'Africa/Lagos', 'UTC', 'America/New_York'
    includeTime?: boolean;     // default true
    includeDate?: boolean;     // default true
    hour12?: boolean;          // default true
    locale?: string;           // default 'en-US'
  }

  export function formatDateTime(
    dateStr: string | Date,
    options: FormatDateTimeOptions = {}
  ): string {
    if (!dateStr) return '';

    const { includeTime = true, includeDate = true } = options;

    let d: Date;

    if (dateStr instanceof Date) {
      d = dateStr;
    } else {
      const s = String(dateStr).trim();

      // Handle pre-formatted UTC string from API e.g. "MAY 08, 2026 11:11AM"
      const preFormatted = s.match(/^([A-Z]{3})\s+(\d{1,2}),\s+(\d{4})\s+(\d{1,2}):(\d{2})(AM|PM)$/i);
      if (preFormatted) {
        const MONTH_MAP: Record<string, number> = {
          JAN:0, FEB:1, MAR:2, APR:3, MAY:4, JUN:5,
          JUL:6, AUG:7, SEP:8, OCT:9, NOV:10, DEC:11
        };
        let h = parseInt(preFormatted[4]);
        const m = parseInt(preFormatted[5]);
        const pm = preFormatted[6].toUpperCase() === 'PM';
        if (pm && h !== 12) h += 12;
        if (!pm && h === 12) h = 0;
        // Treat as UTC since API sends UTC pre-formatted
        d = new Date(Date.UTC(
          parseInt(preFormatted[3]),
          MONTH_MAP[preFormatted[1].toUpperCase()],
          parseInt(preFormatted[2]),
          h, m
        ));
      } else {
        // ISO-style string — strip tz indicators and treat as UTC
        const clean = s.replace(' ', 'T').replace(/\.\d+/, '').replace(/([+-]\d{2}:?\d{2}|Z)$/, '');
        d = new Date(clean + 'Z');
      }
    }

    if (isNaN(d.getTime())) return String(dateStr);

    // Re-format in browser's local timezone
    const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const intlOpts: Intl.DateTimeFormatOptions = {
      timeZone: userTZ,
      ...(includeDate ? { month: 'short', day: '2-digit', year: 'numeric' } : {}),
      ...(includeTime ? { hour: '2-digit', minute: '2-digit', hour12: true } : {}),
    };

    const parts = new Intl.DateTimeFormat('en-US', intlOpts).formatToParts(d);
    const get = (t: string) => parts.find(p => p.type === t)?.value ?? '';

    if (includeDate && includeTime)
      return `${get('month').toUpperCase()} ${get('day')}, ${get('year')} ${get('hour')}:${get('minute')}${get('dayPeriod').toUpperCase()}`;
    if (includeDate)
      return `${get('month').toUpperCase()} ${get('day')}, ${get('year')}`;
    return `${get('hour')}:${get('minute')}${get('dayPeriod').toUpperCase()}`;
  }

  // Parses the same API date shapes formatDateTime handles (pre-formatted
  // "MAY 08, 2026 11:11AM" or ISO-ish strings) into the "YYYY-MM-DD" shape an
  // <input type="date"> requires. Feeding it the raw API string directly left
  // the field blank, since a date input silently rejects any value that isn't
  // exactly that format.
  export function toDateInputValue(dateStr: string | Date | null | undefined): string {
    if (!dateStr) return '';

    let d: Date;
    if (dateStr instanceof Date) {
      d = dateStr;
    } else {
      const s = String(dateStr).trim();
      const preFormatted = s.match(/^([A-Z]{3})\s+(\d{1,2}),\s+(\d{4})\s+(\d{1,2}):(\d{2})(AM|PM)$/i);
      if (preFormatted) {
        const MONTH_MAP: Record<string, number> = {
          JAN:0, FEB:1, MAR:2, APR:3, MAY:4, JUN:5,
          JUL:6, AUG:7, SEP:8, OCT:9, NOV:10, DEC:11
        };
        let h = parseInt(preFormatted[4]);
        const pm = preFormatted[6].toUpperCase() === 'PM';
        if (pm && h !== 12) h += 12;
        if (!pm && h === 12) h = 0;
        d = new Date(Date.UTC(
          parseInt(preFormatted[3]),
          MONTH_MAP[preFormatted[1].toUpperCase()],
          parseInt(preFormatted[2]),
          h, parseInt(preFormatted[5])
        ));
      } else {
        const clean = s.replace(' ', 'T').replace(/\.\d+/, '').replace(/([+-]\d{2}:?\d{2}|Z)$/, '');
        d = new Date(clean + 'Z');
      }
    }

    if (isNaN(d.getTime())) return '';

    const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: userTZ, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d);
    const get = (t: string) => parts.find(p => p.type === t)?.value ?? '';
    return `${get('year')}-${get('month')}-${get('day')}`;
  }

  export function formatPayqartId(id: any): string {
    return String(id ?? '').replace(/pq-/ig, 'PQ-');
  }

  // Parses a promo date string back into the "YYYY-MM-DDTHH:mm" shape a
  // <input type="datetime-local"> requires. Promotion forms across this app submit
  // dates as "DD-MM-YYYY HH:mm:ss" (via DatePipe 'dd-MM-yyyy HH:mm:ss'), which is NOT
  // a format `new Date(str)` can reliably parse — engines differ on how they read
  // dash-separated non-ISO strings, so naive `new Date(dateStr)` silently produces
  // an Invalid Date (blank field) or the wrong date. This parses the parts manually
  // instead of trusting the Date constructor with an ambiguous string.
  export function parsePromoDateToLocalInput(dateStr: string | null | undefined): string {
    if (!dateStr) return '';
    // Already ISO-ish ("YYYY-MM-DDTHH:mm...") — just trim to minute precision.
    if (dateStr.includes('T')) return dateStr.substring(0, 16);

    let year: string | undefined, month: string | undefined, day: string | undefined;
    let time = '00:00';

    try {
      const mainParts = dateStr.trim().split(' ');
      const datePart = mainParts[0];
      if (mainParts.length > 1) {
        time = mainParts[1].substring(0, 5); // HH:mm
      }

      if (datePart.includes('-')) {
        const parts = datePart.split('-');
        if (parts[0].length === 4) {
          // YYYY-MM-DD
          [year, month, day] = parts;
        } else {
          // DD-MM-YYYY
          [day, month, year] = parts;
        }
      } else if (datePart.includes('/')) {
        // DD/MM/YYYY
        [day, month, year] = datePart.split('/');
      }

      if (year && month && day) {
        return `${year}-${month}-${day}T${time}`;
      }
    } catch {
      // fall through to empty-string return below
    }
    return '';
  }

  // 1. status is active, 2. end date is in the past → 3. display "Ended" instead
  // of the raw status. Underlying status is untouched — Disable/Activate still
  // act on the real value.
  export function getPromoDisplayStatus(status: string | null | undefined, endDate: string | null | undefined): string {
    if (status && status.toLowerCase() === 'active' && endDate) {
      const end = new Date(endDate);
      if (!isNaN(end.getTime()) && end.getTime() < Date.now()) {
        return 'Ended';
      }
    }
    return status ?? '';
  }